module.exports = {
  env: process.env.NODE_ENV,
  server: {
    uri:
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_SERVER_URI
        : process.env.REACT_APP_SERVER_URI_DEV,
  },
  client: {
    uri:
      process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_CLIENT_URI
        : process.env.REACT_APP_CLIENT_URI_DEV,
  },
  useMockSpotify: process.env.REACT_APP_USE_MOCK_SPOTIFY,
  commitSha: process.env.REACT_APP_COMMIT_SHA || "d34db33f",
};
